import { render, staticRenderFns } from "./Mark.vue?vue&type=template&id=0898c3d8&scoped=true"
import script from "./Mark.vue?vue&type=script&lang=ts"
export * from "./Mark.vue?vue&type=script&lang=ts"
import style0 from "./Mark.vue?vue&type=style&index=0&id=0898c3d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0898c3d8",
  null
  
)

export default component.exports